
export const listenerQueues = (auth, queues) => {
    return async dispatch => {
        
        queues.forEach(queue => {
            
        });
        
    }
}

